import { PartnersServiceInterface } from 'domain/services';
import {
  CreatePartnerUseCaseInterface,
  CreatePartnerRequestUseCaseInterface,
  GeneratePartnerRequestKeyUseCaseInterface,
  GetAllPartnerRequestsUseCaseInterface,
  GetAllPartnersUseCaseInterface,
  GetKeyPreviewUseCaseInterface,
  TogglePartnerRequestUseCaseInterface,
  UpdatePartnerRequestUseCaseInterface,
  UpdatePartnerUseCaseInterface,
} from 'domain/usecases';

interface UseCasesInjection {
  getAllPartners: GetAllPartnersUseCaseInterface;
  createPartner: CreatePartnerUseCaseInterface;
  updatePartner: UpdatePartnerUseCaseInterface;
  getAllPartnerRequests: GetAllPartnerRequestsUseCaseInterface;
  createPartnerRequest: CreatePartnerRequestUseCaseInterface;
  updatePartnerRequest: UpdatePartnerRequestUseCaseInterface;
  togglePartnerRequest: TogglePartnerRequestUseCaseInterface;
  generatePartnerRequestKey: GeneratePartnerRequestKeyUseCaseInterface;
  getKeyPreview: GetKeyPreviewUseCaseInterface;
}

export class PartnersService implements PartnersServiceInterface {
  private readonly _getAllPartners: GetAllPartnersUseCaseInterface;
  private readonly _createPartner: CreatePartnerUseCaseInterface;
  private readonly _updatePartner: UpdatePartnerUseCaseInterface;
  private readonly _getAllPartnerRequests: GetAllPartnerRequestsUseCaseInterface;
  private readonly _createPartnerRequest: CreatePartnerRequestUseCaseInterface;
  private readonly _updatePartnerRequest: UpdatePartnerRequestUseCaseInterface;
  private readonly _togglePartnerRequest: TogglePartnerRequestUseCaseInterface;
  private readonly _generatePartnerRequestKey: GeneratePartnerRequestKeyUseCaseInterface;
  private readonly _getKeyPreview: GetKeyPreviewUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._getAllPartners = usecases.getAllPartners;
    this._createPartner = usecases.createPartner;
    this._updatePartner = usecases.updatePartner;
    this._getAllPartnerRequests = usecases.getAllPartnerRequests;
    this._createPartnerRequest = usecases.createPartnerRequest;
    this._updatePartnerRequest = usecases.updatePartnerRequest;
    this._togglePartnerRequest = usecases.togglePartnerRequest;
    this._generatePartnerRequestKey = usecases.generatePartnerRequestKey;
    this._getKeyPreview = usecases.getKeyPreview;
  }

  getAllPartners(): Promise<GetAllPartnersUseCaseInterface.Result> {
    return this._getAllPartners.execute();
  }

  createPartner(params: Parameters<CreatePartnerUseCaseInterface['execute']>[0]): Promise<CreatePartnerUseCaseInterface.Result> {
    return this._createPartner.execute(params);
  }

  updatePartner(params: Parameters<UpdatePartnerUseCaseInterface['execute']>[0]): Promise<UpdatePartnerUseCaseInterface.Result> {
    return this._updatePartner.execute(params);
  }

  getAllPartnerRequests(): Promise<GetAllPartnerRequestsUseCaseInterface.Result> {
    return this._getAllPartnerRequests.execute();
  }

  createPartnerRequest(params: Parameters<CreatePartnerRequestUseCaseInterface['execute']>[0]): Promise<CreatePartnerRequestUseCaseInterface.Result> {
    return this._createPartnerRequest.execute(params);
  }

  updatePartnerRequest(params: Parameters<UpdatePartnerRequestUseCaseInterface['execute']>[0]): Promise<UpdatePartnerRequestUseCaseInterface.Result> {
    return this._updatePartnerRequest.execute(params);
  }

  togglePartnerRequest(params: { id: number }): Promise<TogglePartnerRequestUseCaseInterface.Result> {
    return this._togglePartnerRequest.execute(params);
  }

  generatePartnerRequestKey(params: { id: number }): Promise<GeneratePartnerRequestKeyUseCaseInterface.Result> {
    return this._generatePartnerRequestKey.execute(params);
  }

  getKeyPreview(params: Parameters<GetKeyPreviewUseCaseInterface['execute']>[0]): Promise<GetKeyPreviewUseCaseInterface.Result> {
    return this._getKeyPreview.execute(params);
  }
}
